module.exports = __webpack_public_path__ + "media/images/color_admin_v3/gallery/gallery-10-bcbc9e5b12b8b3a060bc08ce86de63c7.jpg";